// Submit form button wait
jQuery(document).ready(function() {
    jQuery(".has-loader").on("click", function() {
        var $this = jQuery(this);
        $this.button("loading");
        setTimeout(function() {
            $this.button("reset");
        }, 14000);
    });
    jQuery("input, textarea").placeholder();
});
